<template>
    <div class="bg-white">
        <v-toolbar color="white">
            <v-toolbar-title class="text-primary">سازمان جدید</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" icon>
                <v-icon color="primary" size="23">close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-form  @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form" class="py-4 px-6">
            <v-text-field
                :rules="$validation('required')"
                class="mb-1"
                label="* عنوان"
                v-model="form.name"
            ></v-text-field>
            <v-select
                :rules="$validation('required')"
                :items="$system.branches"
                class="mb-1"
                item-title="name"
                item-value="id"
                label="* شعبه"
                no-data-text="موردی پیدا نشد!"
                v-if="$auth.user.full_admin"
                v-model="form.branch_id"
            ></v-select>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                        :rules="$validation('required')"
                        :items="$system.customerLevels"
                        item-title="name"
                        item-value="id"
                        label="* سطح سازمان"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.customer_level_id"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <datetime-input
                        type="date"
                        label="تاریخ اتمام دسترسی"
                        clearable
                        v-model="form.expire_date"
                    ></datetime-input>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-text-field
                        :rules="$validation()"
                        label="تلفن ثابت"
                        v-model="form.phone"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        :rules="$validation('url')"
                        label="وبسایت"
                        v-model="form.website"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :items="$system.countries"
                        @update:modelValue="()=>{form.state_id = null; form.city_id = null}"
                        item-title="name"
                        item-value="id"
                        label="کشور"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.country_id"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :disabled="form.country_id ? false : true"
                        :items="$system.states.filter(x=> x.country_id == form.country_id)"
                        @update:modelValue="()=>{form.city_id = null}"
                        item-title="name"
                        item-value="id"
                        label="استان"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.state_id"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :disabled="form.state_id ? false : true"
                        :items="$system.cities.filter(x=> x.state_id == form.state_id)"
                        item-title="name"
                        item-value="id"
                        label="شهر"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.city_id"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-textarea
                :rules="$validation()"
                label="آدرس"
                no-resize
                rows="3"
                v-model="form.address"
            ></v-textarea>
            <v-textarea
                :rules="$validation()"
                label="توضیحات"
                no-resize
                rows="3"
                v-model="form.description"
            ></v-textarea>
            <div class="d-flex">
                <v-btn type="submit" color="success">ثبت اطلاعات</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="closeDialog" color="error" variant="text">انصراف</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                branch_id: null,
                name: null,
                customer_level_id: null,
                phone: null,
                website: null,
                country_id: null,
                state_id: null,
                city_id: null,
                expire_date: null,
                address: null,
                description: null,
            },
        };
    },
    methods: {
        closeDialog() {
            this.$emit("closeAddOrganizationDialog");
            for (const key in this.form) {
                this.form[key] = null;
            }
            if (this.$refs.form)
                this.$refs.form.resetValidation();
        },
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            if (!this.$auth.user.full_admin) delete form.branch_id;
            this.$organizationStore(form).then(async (res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.closeDialog();
                    this.$emit('success');
                }
            });
        },
    },
    async mounted() {
        await this.$system.setStatesCities();
    },
};
</script>
